"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTwoCards", {
  enumerable: true,
  get: function get() {
    return _SVBTwoCards.default;
  }
});
var _SVBTwoCards = _interopRequireDefault(require("./src/SVBTwoCards"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }